import { gql } from "@apollo/client";
export default gql`
    query GetBlockData($block_ids: [Int!]!) {
        worksheet_block(where: { id: { _in: $block_ids } }) {
            id
            order
            parent {
                id
                order
                parent {
                    id
                    data(path: "progress_level.name")
                    worksheets {
                        worksheet {
                            id
                            title
                        }
                    }
                }
            }
        }
    }
`;
